import * as z from "zod";

export const recalculateInventoryProjection = {
  name: "recalculateInventoryProjection" as const,
  input: z.object({}),
  output: z.object({
    /** Backfilling: still loading open orders. Inactive: off for this team. */
    status: z.enum(["started", "backfilling", "inactive"]),
    /** A started pass already finished. Optional so old bundles and servers still parse. */
    passCompleted: z.boolean().optional(),
  }),
};
